import "core-js/modules/es6.array.index-of";
import _styled from "@emotion/styled-base";
import isPropValid from '@emotion/is-prop-valid';
import { iconTheme } from "./themes";
export var IconRoot =
/*#__PURE__*/
_styled('svg', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['color', 'size'].indexOf(prop) === -1 && isPropValid(prop);
  },
  target: "edsisxk0"
})(function (_ref) {
  var color = _ref.color,
      rtl = _ref.rtl,
      size = _ref.size,
      baseTheme = _ref.theme;
  var theme = iconTheme(baseTheme);
  return {
    color: color,
    fill: theme.Icon_fill,
    fontSize: theme.fontSize_base,
    height: theme["Icon_size_" + size] || size,
    transform: theme.direction === 'rtl' && rtl && 'scaleX(-1)',
    width: theme["Icon_size_" + size] || size
  };
});